import React from 'react';

function IconProfile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="19"
      fill="none"
      viewBox="0 0 16 19"
    >
      <path
        fillRule="evenodd"
        d="M11.25 5a3.25 3.25 0 10-6.5 0 3.25 3.25 0 006.5 0zM8 .25a4.75 4.75 0 110 9.5 4.75 4.75 0 010-9.5zM1.75 14.935c0-.544.342-1.028.853-1.211a16.046 16.046 0 0110.794 0c.511.183.853.667.853 1.21v1.316c0 .731-.648 1.293-1.371 1.19l-.955-.137a27.747 27.747 0 00-7.848 0l-.955.136A1.201 1.201 0 011.75 16.25v-1.315zm12.151-2.624a17.545 17.545 0 00-11.802 0A2.786 2.786 0 00.25 14.935v1.315a2.701 2.701 0 003.083 2.674l.955-.136a26.248 26.248 0 017.424 0l.955.136a2.701 2.701 0 003.083-2.674v-1.315c0-1.178-.74-2.228-1.849-2.624z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default IconProfile;
